export function registerServiceWorker(): void {
  if (typeof window === "undefined") {
    return;
  }
  if (!import.meta.env.PROD) {
    return;
  }
  if (!("serviceWorker" in navigator)) {
    return;
  }
  window.addEventListener("load", () => {
    void navigator.serviceWorker.register("/sw.js").catch((error: unknown) => {
      console.warn("Failed to register service worker", error);
    });
  });
}
